import { render, staticRenderFns } from "./DocumentCreateUpdate.vue?vue&type=template&id=04f25176&scoped=true&"
import script from "./DocumentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./DocumentCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCreateUpdate.vue?vue&type=style&index=0&id=04f25176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f25176",
  null
  
)

export default component.exports